import { z } from "zod";

/**
 * HeadingNodeSchema - Content Schema for Heading Node
 *
 * Heading nodes are block-level containers for text and inline elements.
 * Supports H1-H6 heading levels.
 *
 * Nesting constraints (based on Lexical's isInline check):
 * - ✅ Supports: TextNode, StockNode, TagNode, LinkNode, LinebreakNode (inline nodes only)
 * - ❌ Does NOT support: ParagraphNode, ListNode, HeadingNode, QuoteNode (block nodes)
 */
export const HeadingNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("heading"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  tag: z.enum(["h1", "h2", "h3", "h4", "h5", "h6"]), // Heading level (H1-H6)
  children: z.array(z.any()), // Array of child nodes (text, stock, tag, link only)
}).strict();

export type HeadingNode = z.infer<typeof HeadingNodeSchema>;
